import { render } from "./ContainerSwitch.vue?vue&type=template&id=45aca32a&ts=true"
import script from "./ContainerSwitch.vue?vue&type=script&lang=ts"
export * from "./ContainerSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__